import { Action } from '@ngrx/store';
import { ActionOptionsArgs, PersistableAction } from '../../../core/store/actions/base-actions';
import { JobStatusSummary } from './job-status-summary.model';

export const ENTITY = 'jobStatusSummary';
export const SUBMIT = '[JobStatusSummary] Submit';
export const REHYDRATE = '[JobStatusSummary] Rehydrate';
export const REMOVE = '[JobStatusSummary] Remove';

export class SubmitAction extends PersistableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: JobStatusSummary, options?: ActionOptionsArgs) {
        super(payload, {persistable: true, restful: false});
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly entity = ENTITY;
    readonly type = REHYDRATE;

    constructor(public payload: Array<JobStatusSummary>) {

    }
}

export class RemoveAction extends PersistableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: JobStatusSummary, options?: ActionOptionsArgs) {
        super(payload, {persistable: true, restful: false});
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-status-summary-item/job-status-summary.actions.ts